import { defaultQueryBuilderRules } from 'search/AdvancedSearch/consts';
import { getFilterConditionByType } from 'broadcasts/utils';
import {
  AdvancedSearchFilterConditionByReference,
  BroadcastFilterCondition,
  BroadcastFilterConditionType,
  QueryBuilderSubquery,
} from '@ardoq/api-types';
import { AdvancedSearchConditionStreamShape } from './types';
import { ARDOQ_DEFAULT_LOCALE } from '@ardoq/locale';

export const newAdvancedSearchCondition = (
  advancedQuery: QueryBuilderSubquery = defaultQueryBuilderRules,
  outgoingReferencesSelected?: boolean,
  incomingReferencesSelected?: boolean
): AdvancedSearchFilterConditionByReference => ({
  conditionType: BroadcastFilterConditionType.ADVANCED_SEARCH_BY_REFERENCE,
  advancedQuery,
  outgoingReferencesSelected: outgoingReferencesSelected ?? true,
  incomingReferencesSelected: incomingReferencesSelected ?? true,
});

export const getDefaultState = (): AdvancedSearchConditionStreamShape => ({
  isEnabled: false,
  isChecked: false,
  isExpanded: false,
  advancedSearchCondition: newAdvancedSearchCondition(),
  fields: [],
  locale: ARDOQ_DEFAULT_LOCALE,
});

export const findAdvancedSearchCondition = (
  filterConditions: BroadcastFilterCondition[]
) => {
  return getFilterConditionByType(
    filterConditions,
    BroadcastFilterConditionType.ADVANCED_SEARCH_BY_REFERENCE
  );
};
